module.exports = __webpack_public_path__ + "img/4.58d2c911.png";